<template>
  <div class="section-wrapper student-quiz-history">
    <h2 class="section-title">
      {{
        $t("student.practice history title", {
          user: studentName
        })
      }}
    </h2>
    <div v-if="!classroom.loading && classroom.data">
      <van-collapse
        v-model="activeBoxes"
        v-for="(box, index) in boxes"
        :key="`box-${index}`"
      >
        <van-collapse-item
          :name="index"
          :disabled="getPracticedBoxCount(box.id) <= 0"
        >
          <template #title>
            <h3 class="box-title">{{ box.name }}</h3>
          </template>
          <template #icon><i class="fas fa-box"></i></template>
          <template #value> x {{ getPracticedBoxCount(box.id) }}</template>
          <ol
            class="practice-history-list"
            v-if="getPracticedBoxCount(box.id) > 0"
          >
            <li
              v-for="(result, index) in getPracticeHistory(box.id)"
              :key="index"
            >
              {{ result.card }}: x{{ result.seen_count }}
            </li>
          </ol>
        </van-collapse-item>
      </van-collapse>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
export default {
  name: "StudentPracticeHistory",
  components: {},
  data() {
    return {
      studentId: -1,
      classroomId: -1,
      activeBoxes: []
    };
  },
  methods: {
    ...mapActions("vokabel", ["getClassroom"]),
    getPracticeHistory(boxId) {
      const all =
        this.classroomData && this.classroomData["box_state_stats"]
          ? this.classroomData["box_state_stats"]
          : [];
      const result = all.filter(stat => {
        return stat.user.id == this.studentId && stat.box_id == boxId;
      });

      return result.length > 0 && result[0]["seen_cards"]
        ? result[0]["seen_cards"]
        : 0;
    },
    getPracticedBoxCount(boxId) {
      const all =
        this.classroomData && this.classroomData["box_state_stats"]
          ? this.classroomData["box_state_stats"]
          : [];
      const result = all.filter(stat => {
        return stat.user.id == this.studentId && stat.box_id == boxId;
      });
      return result.length > 0 &&
        result[0]["data"] &&
        result[0]["data"]["box_seen_count"]
        ? result[0]["data"]["box_seen_count"]
        : 0;
    }
  },
  computed: {
    ...mapState("vokabel", ["classroom"]),
    ...mapGetters("vokabel", ["getUsername"]),
    classroomData() {
      const { classroom } = this;
      return classroom.data ? classroom.data : {};
    },
    boxes() {
      return this.classroomData && this.classroomData.boxes_list
        ? this.classroomData.boxes_list
        : [];
    },
    studentName() {
      return this.getUsername(
        this.studentId,
        this.classroomData ? this.classroomData.members_list : []
      );
    }
  },
  mounted() {
    this.studentId = this.$route.params.student_id;
    this.classroomId = this.$route.params.classroom_id;
    this.getClassroom(this.classroomId);
  }
};
</script>

<style lang="scss">
.box-title {
  margin-left: 14px;
}
</style>
